import Spinner from '../Spinner'
import React, { ButtonHTMLAttributes, useContext } from 'react'
import { ContextApp } from '@monorepo/service'

const ButtonLoader: React.FC<React.PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>> = ({ children, ...rest }) => {
  const {isCdaPending} = useContext(ContextApp)

  const isLoading = isCdaPending || rest.disabled

  return <button {...rest} disabled={isLoading}>
    {children} {isLoading && <Spinner />}
  </button>
}

export default ButtonLoader
